import { notification } from "antd";
import { useMutation, useQuery } from "react-query";
import { GET, POST } from "../../../../Services";

export const useListarLogrosUsuarioTable = (params = null) => {
    return useQuery(
        ["listarLogrosUsuarioTable", params],
        async () => {
            const response = await GET(
                "logros/listarLogrosUsuarioTable",
                `?${new URLSearchParams(params).toString()}`
            );
            if (response.length == 0) {
                throw new Error("Error al cargar la tabla de logros");
            }
            return response;
        },
        {
            retry: 0,
            keepPreviousData: true,
            refetchOnWindowFocus: false,
            onError: (error) => {
                notification["error"]({
                    message: "Error intentando cargar la tabla de logros",
                });
            },
        }
    );
};

export const useObtenerlogro = () => {
    return useMutation(async (data) => await POST(data, "logros/agregarLogroUsuario"), {
        onSuccess: () => {
            notification["success"]({ message: "Logro otorgador correctamente" });
        },
        onError: (error) => {
            if (error.response && error.response.data?.datos) {
                notification["error"]({ message: error.response.data.mensaje });
            } else {
                notification["error"]({ message: "Error al obtener logro para el usuario" });
            }
        },
    });
};

export const useEliminarLogroUsuario = () => {
    return useMutation(async (data) => await POST(data, "logros/eliminarLogroUsuario"), {
        onSuccess: () => {
            notification["success"]({ message: "Logro eliminado del usuario correctamente" });
        },
        onError: (error) => {
            if (error.response && error.response.data?.mensaje) {
                notification["error"]({ message: error.response.data.mensaje });
            } else {
                notification["error"]({ message: "Error al eliminar logro del usuario" });
            }
        },
    });
};

export const useTipoLogroSelect = (params = null) => {
    return useQuery(
        ["tipoLogro/listarTipos", params],
        async () => {
            const response = await GET(
                "tipoLogro/listarTipos",
                `?${new URLSearchParams(params).toString()}`
            );
            if (response.length == 0) {
                throw new Error("Error al cargar la tabla de logros");
            }
            return response;
        },
        {
            retry: 0,
            keepPreviousData: true,
            refetchOnWindowFocus: false,
            onError: (error) => {
                notification["error"]({
                    message: "Error intentando cargar la tabla de logros",
                });
            },
        }
    );
};

export const useSelectLogros = (params = null) => {
    return useQuery(
        ["logros/selectLogros", params],
        async () => {
            const response = await GET(
                "logros/selectLogros",
                `?${new URLSearchParams(params).toString()}`
            );
            if (response.length == 0) {
                throw new Error("Error al cargar la tabla de logros");
            }
            return response;
        },
        {
            retry: 0,
            keepPreviousData: true,
            refetchOnWindowFocus: false,
            onError: (error) => {
                notification["error"]({
                    message: "Error intentando cargar la tabla de logros",
                });
            },
        }
    );
};

export const useObtenerPokemonUsuario = () => {
  //const api = "pokemon/capturarPokemon";
  const api = "usuarios/obtenerPokemonUsuario"
  return useMutation(async (data) => await POST(data, api), {
    onSuccess: (response) => (response),
    onError: (error) => {
      if (error.response && error.response.data) {
        notification["error"]({ message: error.response.data.mensaje });
      } else {
        notification["error"]({ message: "Acción erronea" });
      }
    },
  });
};

export const useEditarUsuario = () => {
  return useMutation(async (data) => await POST(data, "usuarios/editarUsuario"), {
    onSuccess: () => {
      notification["success"]({ 
        message: "Usuario actualizado",
        description: "Los datos del usuario se han actualizado correctamente"
      });
    },
    onError: (error) => {
      if (error.response && error.response.data?.mensaje) {
        notification["error"]({ 
          message: "Error al actualizar usuario",
          description: error.response.data.mensaje 
        });
      } else {
        notification["error"]({ 
          message: "Error al actualizar usuario",
          description: "No se pudieron guardar los cambios" 
        });
      }
    },
  });
};